import { DOCUMENT } from '@angular/common';
import { Component, Input, OnInit, Inject, ElementRef, ViewChild, Output, EventEmitter, AfterContentInit, AfterContentChecked, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { GenericModalComponent } from '../generic-modal/generic-modal.component';
import { DadosTermoPerfilMock } from '../mock/termo-contrato-registro-mock';
import { DadosTermoRevogacaoPerfilMock } from '../mock/termo-revogacao-registro-mock';
import { ModalContratoComponent } from '../modal-contrato/modal-contrato.component';
import DadosCertificadoModel from '../model/dados-certificado.model';
import { DadosContratosModel } from '../model/dados-contrato.model';
import DadosRegistroModel from '../model/dados-registro.model';
import { DadosRenovaModel } from '../model/dados-renova.model';
import { Grupo, PerfisServicosModel } from '../model/perfis-servicos.model';
import { ServicoModel } from '../model/servico.model';
import { CertificadoService } from '../services/certificado.service';
import { RegistroService } from '../services/registro.service';
import Utils from '../utils/utils';
import { ModalMensagemComponent } from '../modal-mensagem/modal-mensagem.component';
import { AppComponent } from './../app.component';


@Component({
  selector: 'app-renovar-registro',
  templateUrl: './renovar-registro.component.html',
  styleUrls: ['./renovar-registro.component.css']
})
export class RenovarRegistroComponent implements OnInit {

  private renovaForm: FormGroup;
  @ViewChild('contrato') myDiv: ElementRef;
  public dadosCertificado: DadosCertificadoModel;
  public dadosRegistro: DadosRegistroModel;
  public permiteRegistro: boolean;
  private perfilSelecionado: PerfisServicosModel;
  private perfilRevogacao: PerfisServicosModel;
  private revogacaoPerfil: PerfisServicosModel;
  private termoMock: DadosTermoPerfilMock = new DadosTermoPerfilMock();
  private revogacaoMock: DadosTermoRevogacaoPerfilMock = new DadosTermoRevogacaoPerfilMock();
  private dadosContrato: DadosContratosModel;
  public numeroContrato: number;
  bntHabilitado: boolean = false;
  public certificado;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    private certificadoService: CertificadoService,
    private registroService: RegistroService,
    private appComponent: AppComponent
  ) { }

  ngOnInit() {

    setTimeout(() => this.certificadoService.OnInit(), 1000);
    setTimeout(() => this.registroService.OnInit(), 1000);

    this.certificado = this.certificadoService.obterDadosCertificadoServlet();
    this.autenticacoesCertificado();
    this.createForm();
  }

  get possuiRegistro(): boolean {
    return undefined !== this.dadosRegistro && null !== this.dadosRegistro;
  }

  private async obterToken() {
    //token vazio
    // if (!sessionStorage['token'])
      await this.certificadoService.obterToken().then(token => {
        sessionStorage['token'] = token; //grava na sessao..
        return token;
      });
    // else
    //   //token
    //   return sessionStorage['token'];
  }

  private async trataSituacao() {
    if (this.dadosRegistro.nu_inscricao && this.dadosRegistro.nu_inscricao !== '0') {
      //revogação. Pode registrar. direciona para o registro
      if (this.dadosRegistro.situacao === 4 || this.dadosRegistro.situacao === 3) {
        await this.certificadoService.trataRegistroInvalido(this.dadosRegistro.situacao);
        //this.verificaNavegacaoRegistrar();
        this.router.navigate(['/acesso-negado']);
      }
      else {
        if (this.dadosRegistro.situacao > 3) {
          await this.certificadoService.trataRegistroInvalido(this.dadosRegistro.situacao);
          this.router.navigate(['/acesso-negado']);
        }
      }
    } else {
      await this.certificadoService.trataRegistroInvalido(0);
      this.router.navigate(['/acesso-negado']);
    }
  }

  /**
  * Exibe modal com Mensagem.
  */
  mostraDialogMensagem() {
    if (this.dialog.openDialogs.length == 0) {
      const dadosRegistro = this.dadosRegistro;
      this.dialog.open(ModalMensagemComponent, {
        width: '750px',
        data: { dadosRegistro, titulo: 'Mensagem do Sistema' }
      });
    }
  }


  private trataRegistroCAEPF() {
    if (this.dadosRegistro)
      this.dadosCertificado.inscricao = this.dadosRegistro.nu_inscricao;
  }

  private async atualizaSessaoUsuario() {
    sessionStorage['dadosCertificado'] = JSON.stringify(this.dadosCertificado);
    sessionStorage['dadosRegistro'] = JSON.stringify(this.dadosRegistro);
  }

  private async consularSituacaoRegistro() {

    await this.registroService.consultarSituacaoRegistro(this.dadosCertificado).subscribe(
      data => {
        if (data && data['data']) {
          this.setardadosRegistro(data);
          this.registroService.isInscricaoBloqueada(this.dadosRegistro);
          if (this.dadosRegistro !== undefined && !this.dadosRegistro.bloqueado) {
            if (this.dadosCertificado.caepf) {
              this.trataRegistroCAEPF();
            }
            this.trataSituacao();
          }
        }
        this.atualizaSessaoUsuario();
      }
      , err => {

      }
    );
  }

  setardadosRegistro(data) {
    this.dadosRegistro = new DadosRegistroModel();
    this.dadosRegistro.bloqueado = data['data']['bloqueado']===null || data['data']['bloqueado']==='0'? false:true ;
    this.dadosRegistro.situacao =  Number(data['data']['situacao']);
    this.dadosRegistro.nu_certificado = Number(data['data']['nuCertificado']);
    this.dadosRegistro.no_responsavel = data['data']['noResponsavel'];
    this.dadosRegistro.nu_cpf = Number(data['data']['nuCpf']);
    this.dadosRegistro.co_certificado= data['data']['coCertificado'];
    this.dadosRegistro.de_nome_comum= data['data']['deNomeComun'];
    this.dadosRegistro.no_autoridade_certificadora= data['data']['noAutoridadeCertificadora'];
    this.dadosRegistro.nu_perfil= Number(data['data']['nuPerfil']);
    this.dadosRegistro.nu_pis= Number(data['data']['nuPis']);
    this.dadosRegistro.nu_entidade_certificada= Number(data['data']['nuEntidadeCertificada']);
    this.dadosRegistro.de_razao_social= data['data']['deRazaoSocial'];
    this.dadosRegistro.nu_inscricao= data['data']['nuInscricao'];
    this.dadosRegistro.de_perfil= data['data']['dePerfil'];
    this.dadosRegistro.ic_tipo_perfil= Number(data['data']['icTipoPerfil']);
    this.dadosRegistro.ic_tipo_restricao= Number(data['data']['icTipoRestricao']);

  }

  async autenticacoesCertificado() {

    //grava token da sessao do certificado
    await this.obterToken().then(token => {     
    });
    //obtem certificado
    if (!sessionStorage['dadosCertificado']) {
      await this.certificadoService.obterCertificadoPorToken().then(certificado => {
        this.dadosCertificado = certificado;
      })
        .catch(err => {
          console.error(err);
        });
    } else {
      this.dadosCertificado = JSON.parse(sessionStorage['dadosCertificado']);
    }

   // if (0 === +this.dadosCertificado.inscricao){
   //   this.dadosCertificado.caepf = true;
   // }

    let certValido = false;
    //valida cetificado
    await this.certificadoService.validaCertificado(this.dadosCertificado).then(isValido => {
      if (!isValido)
        certValido = true;
    }).catch(err => {
      console.log('erro validaCertificado(): ' + err)
    });

    if (certValido) {
      // Verifica Situacao da Inscricao
      await this.registroService.consultarSituacaoRegistro(this.dadosCertificado).subscribe(
        data => {
          if (data && data['data']) {
            this.setardadosRegistro(data);
            this.registroService.isInscricaoBloqueada(this.dadosRegistro);

            if (this.dadosRegistro.nu_inscricao && this.dadosRegistro.nu_inscricao !== '0') {

              if (!this.dadosRegistro.bloqueado  && (this.dadosRegistro.situacao !== 4 && this.dadosRegistro.situacao !== 3)) {

                this.trataSituacao();

              } else {

                this.permiteRegistro = true;
              }

            } else {
              this.permiteRegistro = true;
            }


          }
          this.atualizaSessaoUsuario();
        }
        , err => {
          console.error(err);
        }
      );
    }
    //Tratamento Token (TKN) Se Token nao permite Renovar
    const orgaoTkn = this.certificadoService.getOrgaoEmissor(this.dadosCertificado).trim()
    if (orgaoTkn === 'Caixa Economica Federal') {
      this.permiteRegistro = false;
      await this.certificadoService.trataMessageToken();
      this.router.navigate(['/acesso-negado']);
    }

    // Verifica Situacao da Inscricao
    this.consularSituacaoRegistro();


  }

  private createForm() {
    this.renovaForm = this.fb.group(
      {
        // cmbPerfil: new FormControl(),
        chkContrato: [false, Validators.pattern('true')],
        chkRevogacao: [false, Validators.pattern('true')],
        contrato: ''
      });
  }

  atualizaPerfil(perfis: PerfisServicosModel[]) {
    //[perfilSelecionado, this.perfilRevogacao];
    this.perfilSelecionado = perfis[0];
    this.perfilRevogacao = perfis[1];
    this.revogacaoPerfil = perfis[2]

  }

  get mostraChecks(): boolean {
    return this.isPerfilValido;
  }

  get isPerfilValido(): boolean {
    return this.perfilSelecionado !== undefined && this.perfilSelecionado.isValido;
  }

  //Revogacao aceito
  get chkRevogacao() {
    return this.renovaForm.get("chkRevogacao").value;
  }

  //Contrato aceito
  get chkContrato() {
    return this.renovaForm.get("chkContrato").value;
  }

  get mostraBtnRegistrar(): boolean {
    return this.isPerfilValido && this.chkRevogacao && this.chkContrato;
  }

  get habilitaBtn(): boolean {
    return this.bntHabilitado;
  }

  //metodo auxilar do Contrato..
  private obterContrato(modal) {
    if (modal)
      return this.myDiv.nativeElement.innerHTML
    else
      return this.myDiv.nativeElement.innerText;
  }

  //metodo auxilar do Contrato..
  private obterDescricaoPerfil() {
    return this.perfilSelecionado.descPerfil;
  }
  //metodo auxilar do Termo Revogacao..
  private obterDescricaoPerfilRevogado() {
    return this.dadosRegistro.de_perfil;
  }

  private obterListaServicos(grupos: Grupo[]): string[] {
    //servico
    let servico = new ServicoModel();
    const listaServicos: string[] = [];

    grupos.map((item) => {
      item.servicos.map((itemServico) => {
        servico.nuServico = itemServico.idServico;
        servico.deServico = itemServico.descServico;
        listaServicos.push(servico.deServico);
      });
    });
    return listaServicos;
  }

  private obterListaServicosTermoRevogacao() {

    if (this.perfilRevogacao === undefined) {
      return this.obterListaServicos(this.revogacaoPerfil.grupos);
    } else {
      return this.obterListaServicos(this.perfilRevogacao.grupos);
    }
  }

  private obterListaServicosContrato() {

    const grupos = this.perfilSelecionado.grupos;
    return this.obterListaServicos(grupos);
  }

  obterTipoContrato() {
    let tipoRestricao = this.perfilSelecionado.tipoNovoRestricao
    let restricaoNumber = parseInt(tipoRestricao, 10)
    if(restricaoNumber === 0){
      return "AMPLO"
    }else{
      return "RESTRITO"
    }
  }

  async setardadosContrato() {
    this.dadosContrato = new DadosContratosModel();
    this.dadosContrato.titulo = 'Contrato';
    this.dadosContrato.contrato = this.obterContrato(true);
    this.dadosContrato.desPerfil = this.obterDescricaoPerfil();
    this.dadosContrato.inscricao = this.dadosCertificado.inscricao + '';
    this.dadosContrato.razaoSocial = this.dadosCertificado.razaoSocial;
    this.dadosContrato.tipoInscricao = this.dadosCertificado.tpInscricao + '';
    this.dadosContrato.servicos = this.obterListaServicosContrato();
    this.dadosContrato.tipoContrato = this.obterTipoContrato();
  }

  async setardadosTermoRevogacao() {
    this.dadosContrato = new DadosContratosModel();
    this.dadosContrato.titulo = 'Termo de Revogação';
    this.dadosContrato.contrato = this.obterContrato(true);
    this.dadosContrato.desPerfil = this.obterDescricaoPerfilRevogado();
    this.dadosContrato.inscricao = this.dadosCertificado.inscricao + '';
    this.dadosContrato.razaoSocial = this.dadosCertificado.razaoSocial;
    this.dadosContrato.tipoInscricao = this.dadosCertificado.tpInscricao + '';
    this.dadosContrato.servicos = this.obterListaServicosTermoRevogacao();
    this.dadosContrato.tipoContrato = this.obterTipoContrato();
  }

  /**
   * Exibe modal com Contrato.
   */
  mostraDialogTermoRevogacao() {
    this.setardadosTermoRevogacao().then(() => {
      const dadosContratos = this.dadosContrato;
      dadosContratos.isRenovacao = true;
      dadosContratos.titulo = 'Termo Revogação';
      if (this.isPerfilValido) {
        this.dialog.open(ModalContratoComponent, {
          width: '750px',
          data: { dadosContratos },
        });
      }
    });
  }

  /**
 * Exibe modal com Contrato.
 */
  mostraDialogContrato() {
    this.setardadosContrato().then(() => {
      const dadosContratos = this.dadosContrato;
      dadosContratos.isRenovacao = false;
      dadosContratos.titulo = 'Contrato';
      if (this.isPerfilValido) {
        this.dialog.open(ModalContratoComponent, {
          width: '750px',
          data: { dadosContratos },
        });
      }
    });
  }

  //Action do link Revogacao..
  lerTermoRevogacao() {
    this.mostraDialogTermoRevogacao();
  }
  //Action do link Contrato..
  lerContrato() {
    this.mostraDialogContrato();
  }


  private get inscricao(): string {
    return this.dadosCertificado.caepf ? this.dadosRegistro.nu_inscricao : this.dadosCertificado.inscricao;
  }

  private async getImagemRevogacaoChancela(): Promise<String> {
    this.setardadosTermoRevogacao();
    const termoTxt = this.dadosContrato.tipoInscricao === '3' ?
      this.revogacaoMock.textoTermoRevogacaoFisico(this.dadosContrato) :
      this.revogacaoMock.textoTermoRevogacaoJuridico(this.dadosContrato);
    return termoTxt;
  }

  private async getImagemChancela(isContrato: boolean): Promise<string> {

    if (isContrato === true) {
      this.setardadosContrato();
    } else {
      this.setardadosTermoRevogacao();
    }

    const termoTxt = this.dadosContrato.tipoInscricao === '3' ?
      this.termoMock.textoTermoAceiteFisico(this.dadosContrato) :
      this.termoMock.textoTermoAceiteJuridico(this.dadosContrato);
    return termoTxt;
  }

  private async getImagemAssinaturaContrato(): Promise<string> {
    this.setardadosContrato();
    const imagemChancela: string = await this.getImagemChancela(true);
    const termoAceite: any = await this.certificadoService.assinarCriptoCns(this.dadosCertificado, imagemChancela, false);
    if (!termoAceite) this.bntHabilitado = false;
    return termoAceite;

  }

  private async getImagemAssinaturaRevogacao(): Promise<string> {

    this.setardadosTermoRevogacao();
    const imagemChancela: String = await this.getImagemRevogacaoChancela();
    //const termoAceite: any = await this.certificadoService.assinarTermo(this.dadosCertificado, imagemChancela);
    const termoAceite: any = await this.certificadoService.assinarCriptoCns(this.dadosCertificado, imagemChancela, false);
    if (!termoAceite) this.bntHabilitado = false;
    return termoAceite;
  }

  private get tipoChancela() {
    if (PerfisServicosModel.isRestrito(this.perfilSelecionado)) {
      return "1";
    } else {
      return "2";
    }
  }

  private get ultimoTipoChancela() {
    if (PerfisServicosModel.isRestrito(this.perfilSelecionado)) {
      return "1";
    } else {
      return "2";
    }
  }

  obterNumeroServicos() {

    const nuServico: number[] = [];
    this.perfilSelecionado.grupos.map((item) => {
      item.servicos.map((itemServico) => {
        nuServico.push(+itemServico.idServico);
      });
    });
    return nuServico;
  }

  private async preparaParams(): Promise<DadosRenovaModel> {

    const param: DadosRenovaModel = new DadosRenovaModel();

    param.numInscricao = Utils.inscricaoQuinzeDigitos(this.inscricao, this.dadosCertificado.tpInscricao + '');
    const nomeAutCert = this.certificadoService.getNomeEntidadeCert(this.dadosCertificado);
    param.autoridadeCertificadora = nomeAutCert;
    param.coSerial = this.dadosCertificado.codigoSerial + '';
    param.numeroPerfil = this.perfilSelecionado.idPerfil;

    // param.p002r_DataChancela = this.dadosCertificado.;
    param.p002rImagemChancela = await this.getImagemChancela(false);
    param.p002rImagemAssinatura = await this.getImagemAssinaturaRevogacao();
    param.p002rImagemAssinaturaSistema = param.p002rImagemAssinatura; //uso o mesmo

    // param.p002n_DataChancela = this.dadosCertificado.;
    param.p002nImagemChancela = await this.getImagemChancela(true);
    param.p002nImagemAssinatura = await this.getImagemAssinaturaContrato();
    param.p002nImagemAssinaturaSistema = param.p002nImagemAssinatura; //uso o mesmo
    param.p002nTipoChancela = this.tipoChancela; //RESTRITO OU AMPLO

    param.p003TipoContrato = '1';
    // param.p003_DataUltimaChancela = this.dadosCertificado.;
    param.p003UltimoTipoChancela = this.ultimoTipoChancela;

    param.servicos = this.obterNumeroServicos();

    return param;
  }

  // private atualizarPerfilTopo(){
  //   this.dadosRegistro.de_perfil = this.perfilSelecionado.descPerfil;
  // }

  private async persiste() {

    const params = await this.preparaParams();
    const renova = await this.registroService.renova(params).then(data => {
      const mensagem = data['status'];
      if (mensagem == "200") {
        this.numeroContrato = +data['numeroContrato'];
        this.router.navigate(['sucesso', this.numeroContrato, this.tipoChancela, 'renovar', this.perfilSelecionado.idPerfil]);
      }
    });
  }

  async renovar() {


    if (this.verificaInstalacaoCriptocnsKry()) {
      this.bntHabilitado = true;
      //Prepara Contrato para assinatura Kriptonite
      await this.setardadosContrato();
      //Prepara Termo Revogacao para assinatura Kriptonite
      await this.setardadosTermoRevogacao();
      //Persiste

      await this.persiste();
      //Atualiza dados
      await this.consularSituacaoRegistro();
      this.bntHabilitado = false;
    }
  }

  verificaNavegacaoRegistrar() {
    let valido = this.dadosCertificado.caepf ? 0 : 1;
    if (valido === 0)
      this.router.navigate(['/registrar', valido, this.dadosRegistro.nu_inscricao])
    else
      this.router.navigate(['/registrar']);
  }

  async verificaInstalacaoCriptocnsKry() {

    return await this.appComponent.verificaAPICriptoCNS();
  }

}
